<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="two_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">OM:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_om" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">По гестації:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_gastatsia" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Термін пологів:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_termin" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Вага:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_vaga" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кількість плодів:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_plodiv">
            <option value="один">один</option>
            <option value="два">два</option>
            <option value="три">три</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Положення прода:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_poloz">
            <option value="поздовжнє">повздовжнє</option>
            <option value="поперечне">поперечне</option>
            <option value="косе">косе</option>
            <option value="нестійке">нестійке</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Предлежання:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_pred">
            <option value="головне">головне</option>
            <option value="сідничне">сідничне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_sertse">
            <option value="ритмічне">ритмічне</option>
            <option value="аритмічне">аритмічне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧСС:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="two_chss" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рухи плода:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="two_moves" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <table class="table">
          <caption>
            Параметри плода
          </caption>
          <thead>
          <tr>
            <th class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Параметри плода</th>
            <th class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">мм</th>
            <th class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Параметри плода</th>
            <th class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">мм</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Біпарієтальний розмір (БПР)</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_bpr" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Нирка права</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_nurka_right" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Лобно-потиличний розмір (ЛПР)</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_lpr" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Нирка зліва</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_nurka_left" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Окружність голови</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_head_okr" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Сечовий міхур</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_setch_mikhur" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Цефалічний індекс</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_tsefal_index" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжини стегна</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_dovz_stegna" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Мозочок</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_mozochok" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина великої бедрової кістки</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_vel_bedr_kist" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Інтраокулярний розмір</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_intraokul_rozmir" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина малої бедрової кістки</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_dozv_mal_bedr_kist" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Діаметр грудної клітини (СДГК)</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_sdgk" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Стопа</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_stopa" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Серед. діаметр живота(СДЖ)</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_diam_zuv" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина плеча</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_dovz_plecha" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Окружність живота</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_okr_zuvota" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина ліктьової кістки</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_dovz_likt" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Серце</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_sertse_mm" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина променевої кістки</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_dovz_promenevoi" />
              </clr-input-container>
            </td>
          </tr>

          <tr>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Шлунок</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_shlunok" />
              </clr-input-container>
            </td>
            <td class="left" [ngStyle]="{ 'font-size.px': options.fontSize }">Кисть</td>
            <td>
              <clr-input-container>
                <input autocomplete="off"
                       [ngStyle]="{ 'font-size.px': options.fontSize }"
                       placeholder="" clrInput name="name" formControlName="two_kust" />
              </clr-input-container>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Структура мозку:</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серединне М-ехо:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_sered_exo" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Бокові шлуночки мозку:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_bok_sh_mozku" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Велика цистерна:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_big_tsusterna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Задні рога бокових шлуночків:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_zadni_roga" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('б/о', 'two_stovbur')"> б/о </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('мм.', 'two_stovbur')"> мм. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Хребтовий стовбур:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_stovbur"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('положення', 'two_hearth')"> положення </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('нормальне', 'two_hearth')"> нормальне </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('аномальне', 'two_hearth')"> аномальне </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(', 4-камерний зріз серця:', 'two_hearth')"> 4-камерний зріз серця: </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізуються', 'two_hearth')"> візуалізуються </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('чітко не візуалізуються', 'two_hearth')"> чітко не візуалізуються </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(', клапани:', 'two_hearth')"> клапани </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('норма', 'two_hearth')"> норма </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(', камери:', 'two_hearth')"> камери </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(', хід магістральних судин серця', 'two_hearth')"> хід магістральних судин серця </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('правильний', 'two_hearth')"> правильний </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не правильний', 'two_hearth')"> не правильний </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('легенева артерія  мм,', 'two_hearth')"> легенева артерія </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('аорта  мм', 'two_hearth')"> аорта </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серце:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_hearth"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('б/о', 'two_diafragma')"> б/о </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('патологія', 'two_diafragma')"> патологія </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізуються', 'two_diafragma')"> не візуалізуються </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Діафрагма:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_diafragma"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ехогенність:', 'two_kushechnuk')"> ехогенність </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не підвищена', 'two_kushechnuk')"> не підвищена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('підвищена', 'two_kushechnuk')"> підвищена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(', петлі', 'two_kushechnuk')"> петлі </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('не розширені', 'two_kushechnuk')"> не розширені </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('розширені до  мм', 'two_kushechnuk')"> розширені </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кишечник:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_kushechnuk"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('цілісна', 'two_perednya_cherevna')"> цілісна </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Передня черевна стінка:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_perednya_cherevna"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-small-padding text-left bold-text">
          <strong>Структура обличчя</strong>
        </div>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізуються', 'two_luts_rozshilunu')"> не візуалізуються  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізуються', 'two_luts_rozshilunu')"> візуалізуються  </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лицьові розщілини:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_luts_rozshilunu"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Носова кістка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_nosova_kistka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розмір шийної складки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_rozmir_skladku" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('нормальна', 'two_kilkist_vod')"> нормальна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('збільшена', 'two_kilkist_vod')"> збільшена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('зменшена', 'two_kilkist_vod')"> зменшена </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('АІ', 'two_kilkist_vod')"> АІ </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кількість навколоплідних вод:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_kilkist_vod"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('передня', 'two_local_plats')"> передня </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('задня', 'two_local_plats')"> задня </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('права бокова', 'two_local_plats')"> права бокова </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ліва бокова стінки', 'two_local_plats')"> ліва бокова стінки </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('дно матки', 'two_local_plats')"> дно матки </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Локалізація плаценти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_local_plats"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Нижній край плаценти на :</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_nuz_platsenty" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина плаценти:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_tov_platsenty" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура плаценти:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_str_platsenty" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Реверсний кровоток у венозній протоці:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_revers_krovotok" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-small-padding text-left bold-text">
          <strong>Пуповина</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кількість судин:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_kilk_sudun" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Обвиття пуповини:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_obv_pupovunu">
            <option value="є">є</option>
            <option value="ні">ні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Передлежання судин пуповини:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_pered_sudun">
            <option value="є">є</option>
            <option value="ні">ні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Оболонкове прикріплення судин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="two_obol_prukrip">
            <option value="є">є</option>
            <option value="ні">ні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Шийка матки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_shuyka_matku" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Вн.вічко:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_vnut_vichko" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Підозра або наявні вади розвитку плода (ВВР):</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="two_pidozra" />
        </clr-input-container>
      </div>
    </div>


    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('Величина плоду відповідає на  т. д.', 'two_results')"> величина плоду відповідає на  т. д. </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Висновок УЗД:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_results"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рекомендації:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="two_recomends"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
